<template>
  <div class="container-fluid">
    <div class="row">
      <div class="d-none d-md-block col-3 pt-5 login-banner"></div>

      <div class="col p-4">
        <p class="text-black-50 text-right">
          ¿Aún no tienes cuenta?
          <router-link to="/register" class="text-dark">Regístrate</router-link>
        </p>

        <div class="text-center py-4" style="max-width: 376px; margin: auto">
          <MobiusLogo to="/home" />

          <h1 class="text-dark font-h3 mt-5">Ingresa para practicar</h1>

          <!-- Social login -->
          <button
            ref="googleLoginButton"
            @click="loginWithGoogle()"
            class="btn btn-social w-100 mt-4"
          >
            <svg
              width="18"
              height="18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.58 9.168c0-.737-.06-1.275-.19-1.834H8.969v3.329h4.943c-.1.827-.638 2.073-1.834 2.91l-.016.111 2.662 2.063.184.018c1.695-1.564 2.671-3.866 2.671-6.597z"
                fill="#4285F4"
              />
              <path
                d="M8.97 17.938c2.42 0 4.454-.797 5.939-2.172l-2.83-2.193c-.758.528-1.774.897-3.11.897-2.372 0-4.385-1.564-5.102-3.727l-.105.01-2.769 2.142-.036.1a8.963 8.963 0 008.012 4.943z"
                fill="#34A853"
              />
              <path
                d="M3.867 10.743a5.522 5.522 0 01-.3-1.774c0-.618.11-1.216.29-1.774l-.005-.119L1.048 4.9l-.091.044A8.977 8.977 0 000 8.969c0 1.445.349 2.81.957 4.026l2.91-2.252z"
                fill="#FBBC05"
              />
              <path
                d="M8.97 3.468c1.683 0 2.82.728 3.467 1.335l2.532-2.471C13.414.887 11.39 0 8.969 0A8.963 8.963 0 00.957 4.943l2.9 2.252c.727-2.162 2.74-3.727 5.112-3.727z"
                fill="#EB4335"
              />
            </svg>
            Iniciar sesión con Google
          </button>


          <!-- End Social login -->

          <span class="d-block text-center mt-4 mb-3 text-black-50">
            O puedes ingresar con
          </span>

          <!-- Login form -->
          <form>
            <div class="form-group">
              <label for="email">Correo</label>
              <input class="form-control form-inline" type="email" v-model="loginInfo.email" id="email"/>
              <small v-if="formErrorMessage.email" class="error-hint">{{
                formErrorMessage.email
              }}</small>
            </div>
            <div class="form-group">
              <label for="password">Contraseña</label>
              <input class="form-control form-inline" type="password" v-model="loginInfo.password" id="password"/>
              <small v-if="formErrorMessage.password" class="error-hint">{{
                formErrorMessage.password
              }}</small>
            </div>
            <div v-if="formErrorMessage.server" class="error-message">
              <small>{{ formErrorMessage.server }}</small>
            </div>
            <router-link to="/recover-password" class="text-small text-black-50 mt-2">Olvidé mi contraseña</router-link>
            <button
              @click.prevent="localLogin"
              class="btn btn-primary w-100 mt-2"
            >
              Iniciar sesión
            </button>
          </form>
          <!-- End Login form -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import MobiusLogo from "@/components/MobiusLogo.vue";

export default {
  name: "Login",
  components: { MobiusLogo },
  data() {
    return {
      loginInfo: {
        username: "",
        email: "",
        password: "",
      },
      formErrorMessage: {
        email: null,
        password: null,
        server: null,
      },
    };
  },
  methods: {

    getUserData(token) {
      let loader = this.$loading.show({});
      axios
        .get(import.meta.env.VITE_API_BASE_URL + "/user/me", {
          params: { },
          headers: {
            Authorization: 'Bearer ' + token
          }
        })
        .then((response) => {
          loader.hide();
          if(response.data && (response.data.emailVerified || ['google', 'facebook'].includes(response.data.provider))) {
            this.$store.dispatch("auth/setLogin", {
              ...response.data,
              ...{token: token}
            });
            this.$router.push("/dashboard");
          } else {
            this.$store.dispatch("auth/logout");
            this.$toasted.info("Por favor verifica tu email para continuar.", {position: 'top-center', duration: 3000});
          }
        })
        .catch((err) => {
          console.log(err.message);
          loader.hide();
        });
    },

    localLogin() {
      if (this.validateLoginInfo()) {
        this.loginInfo.username = this.loginInfo.email;
        axios
          .post(
            import.meta.env.VITE_API_BASE_URL + "/auth/login",
            this.loginInfo
          )
          .then((response) => {
            this.getUserData(response.data.accessToken);
          })
          .catch((error) => {
            console.log(error);
            this.$toasted.error("Correo o contraseña inválido.", {position: 'top-center', duration: 3000});
          });
      }
    },
    facebookLoginV2() {
      window.location.href = import.meta.env.VITE_FACEBOOK_AUTH_URL;
    },
    googleLoginV2() {
      window.location.href = import.meta.env.VITE_GOOGLE_AUTH_URL;
    },
    loginWithGoogle() {
      const authWindow = window.open(
          import.meta.env.VITE_GOOGLE_AUTH_URL + '&response_type=token&scope=email',
        'googleAuthPopup',
        'width=500,height=600'
      );
      window.addEventListener('message', event => {
        console.log(event)
        if (event.origin === window.location.origin && event.data.type === 'googleAuth') {
          authWindow.close();
          this.goToDashboard();
        }
      });
    },
    goToDashboard() {
      // Redirect to dashboard
      this.$router.push("/dashboard");
    },
    validateLoginInfo() {
      let errorCount = 0;

      if (!this.loginInfo.email) {
        this.formErrorMessage.email = "Este campo es requerido";
        errorCount++;
      } else {
        this.formErrorMessage.email = null;
      }
      if (!this.loginInfo.password) {
        this.formErrorMessage.password = "Este campo es requerido";
        errorCount++;
      } else {
        this.formErrorMessage.password = null;
      }

      return errorCount === 0;
    },
  },
  mounted() {
    if(this.$route.query.error) {
      this.$toasted.error(localStorage.getItem("loginError"), {position: 'top-center', duration: 5000});
      localStorage.removeItem("loginError");
    }
    const authInfo = JSON.parse(window.localStorage.getItem("auth"));
    if ((authInfo && authInfo.isAuthenticated)) {
      this.goToDashboard()
    }
  },
};
</script>

<style scoped>
.login-banner {
  background-image: url("../assets/images/login-banner.jpg");
  min-height: 100vh;
  background-size: cover;
  background-position: center;
  max-width: 430px;
}
</style>
